<template>
  <div :class="classes()">
    <div :class="`${el}__inner`">
      <Headline v-if="headline" :heading="2" size="s" centered responsive noMargin>
        {{ headline }}
      </Headline>
      <Copy v-if="subline" color="primaryBlue" element="div" size="xl" bold centered responsive>
        {{ subline }}
      </Copy>
      <Copy v-if="copy" :staticClass="`${el}__copy`" element="div" centered>
        {{ copy }}
      </Copy>
      <div v-if="$slots.form" :class="headline || subline || copy ? `${el}__form` : ''">
        <slot name="form" />
      </div>
    </div>
    <div :class="`${el}__bottomWrapper`" v-if="$slots.bottom">
      <Divider v-if="$matchMedia.l" dotted />
      <div :class="`${el}__bottom`">
        <slot name="bottom" />
      </div>
    </div>
  </div>
</template>

<script>
import Divider from '@/objects/Divider';
import Headline from '@/objects/Headline';
import Copy from '@/objects/Copy';

export default {
  name: 'FormBox',
  props: {
    headline: String,
    subline: String,
    copy: String,
  },
  components: {
    Divider,
    Headline,
    Copy,
  },
  data() {
    return {
      el: 'c-formBox',
      classes: () => {
        const el = this.el;
        return {
          [el]: true,
        };
      },
    };
  },
};
</script>
